module.exports = __webpack_public_path__ + "static/media/ic_google_login.1e4e4623.svg";